export enum PlanCustomizationInteraction {
  ProceedToPayment = 'proceed_to_payment',
  Initialize = 'initialize',
  GetProductPageData = 'get_product_page_data',
  InitializeFormsController = 'initialize_forms_controller',
}
